import DbEntity from "./DbEntity";

export default class Mezzi extends DbEntity {
	constructor() {
		super("mezzi");
	}
}